export default __webpack_public_path__ + "static/media/up-arrow.6c169722.svg";